import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface ReusableEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const ReusableEditor: React.FC<ReusableEditorProps> = ({ value, onChange }) => {
  const quillRef = useRef<ReactQuill>(null);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const containerStyle = {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "white",
  };

  return (
    <>
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        theme="snow"
        style={containerStyle}
      />
    </>
  );
};

export default ReusableEditor;
